function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab24f111-aa59-4341-b539-b878bddc95e6{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b004269b-42b6-47a3-9943-9bc979ead07f",
  "data-name": "Basics"
}, /*#__PURE__*/React.createElement("g", {
  id: "a72b3638-c135-497a-accd-1a15976d2869",
  "data-name": "basics komponenten"
}, /*#__PURE__*/React.createElement("path", {
  id: "b0f5904e-0956-4c25-ac9d-c1a2b88b9749",
  "data-name": "Fill-7",
  className: "ab24f111-aa59-4341-b539-b878bddc95e6",
  d: "M25,30.5A2.5,2.5,0,1,1,22.5,33,2.5,2.5,0,0,1,25,30.5Zm0-8A2.5,2.5,0,1,1,22.5,25,2.5,2.5,0,0,1,25,22.5Zm0-8A2.5,2.5,0,1,1,22.5,17,2.5,2.5,0,0,1,25,14.5Z"
})));

var SvgIconMore = function SvgIconMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f577b7e1-af15-426d-a678-f736ea48c497",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-more.dfa7433a.svg";
export { ForwardRef as ReactComponent };